var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12H16C13.79 12 12 13.79 12 16V32C12 34.21 13.79 36 16 36H32C34.21 36 36 34.21 36 32V16C36 13.79 34.21 12 32 12ZM34 32C34 33.1 33.1 34 32 34H16C14.9 34 14 33.1 14 32V16C14 14.9 14.9 14 16 14H32C33.1 14 34 14.9 34 16V32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14H16C14.8954 14 14 14.8954 14 16V32C14 33.1046 14.8954 34 16 34H32C33.1046 34 34 33.1046 34 32V16C34 14.8954 33.1046 14 32 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/ic-checkbox-unchecked.68e14f777c46b343641e88cba038e047.svg";
export { ForwardRef as ReactComponent };